
<template>
  <div ref="SchedulerComponent"></div>
</template>

<script>
import { scheduler } from "dhtmlx-scheduler";
import { DefaultBookingType, DefaultBookingStatus } from './data';

function dateFormJoiner(date) {
  const dateStr = String(date);
  const dateParts = dateStr.split(' ');
  const dateParts1 = dateParts[0].split('-')
  //  console.log(date, dateStr);
  const newDateStr = dateParts1[2] + '/' + dateParts1[1] + '/' + dateParts1[0] + ' ' + dateParts[1];

  return newDateStr;
}

export default {
  emits: ['search-submit', 'venueId'],
  name: 'BookingCalendar',
  props: {
    events: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      numberOfDays: null,
      afterhour: false,
      eventPax: null,
    }
  },
  methods: {    
    $_initDataProcessor: function() {
      if (!scheduler.$_dataProcessorInitialized) {
        scheduler.createDataProcessor((action, data, id) => { 
          var date = id;
          this.endDate = date.end_date
          this.startDate = date.start_date
          this.eventPax = date.people
          this.submitSearch()
        });
        scheduler.$_dataProcessorInitialized = true;
      }
    },

    getNumberOfDays(startDate, endDate) {
      
      let start = startDate.split(' ');
      let end = endDate.split(' ');
      start = Date.parse(start[0]);
      end = Date.parse(end[0]);

      let numberOfDays = (end - start) / 1000 / 3600 / 24;

      // special case, is afterhour. when over 8 hour and ending 5:30 or after

      return numberOfDays;
      //  console.log('number of days', this.numberOfDays);
    },
    
    generateBookingDateObject(startDate, numberOfDays) {
      // this.getNumberOfDays(this.startDate, this.endDate);
      let dates = [];

      let factor = 1000 * 3600 * 24;
      let _startDT = new Date(Date.parse(startDate));
      // let endDT = new Date();
      for (let i = 1; i <= this.numberOfDays; i++) {
        let _endDT = new Date(Date.parse(_startDT) + factor);
        let dateStr =
          _startDT.getDate() +
          '/' +
          (_startDT.getMonth() + 1) +
          '/' +
          _startDT.getFullYear();

        if (numberOfDays > 1) {
          this.startTime = '08:00';
          this.endTime = '19:00';
        }

        let dateObject = {
          StartDate: dateStr,
          EndDate: dateStr,
        };
        dates.push(dateObject);
        _startDT = _endDT;
      }

      return dates;
    },

    submitSearch() {
      let maxUnits = this.fieldCloseHour * 2;
      let minimalOrder = maxUnits - this.units;
      if (minimalOrder < 2) {
        //   console.log(' minimal order is 60 minutes', maxUnits, this.units);
        this.$emit('search-submit', null);
        return;
      }

      if (this.bookingType === 'causal') { // KI 14Jul2022. Added one = to make ===
        this.endDate = this.startDate;
        this.numberOfDays = 1;
      } else {
        this.numberOfDays =
          this.getNumberOfDays(this.startDate, this.endDate) + 1;
      }
      console.log(this.numberOfDays);

      var _startDate = dateFormJoiner(this.startDate); //this.startDate.replaceAll('-', '/');
      var _endDate = dateFormJoiner(this.endDate); //this.startDate.replaceAll('-', '/');

      const slotObject = {
        StartDate: _startDate,
        EndDate: _endDate,
        VenuePax: this.eventPax, // 0 or 1000 makes not different therefore use 0

        VenueBookingType: DefaultBookingType,
        VenueBookingStatus: DefaultBookingStatus,

        NumberOfDays: this.numberOfDays,
        AfterHour: this.afterhour,
        Dates: this.generateBookingDateObject(
          this.startDate,
          this.numberOfDays
        ),
      };

      console.log(      
        slotObject,
        this.startDate,
        this.endDate,
        this.numberOfDays
      );

      this.$emit('search-submit', slotObject);
      this.$eventBus.emit('search-submit', []);
    },
  },
  mounted: function () {
    // var dateString1 = '2022-09-17 1:00'
    // var dateString2 = '2022-09-17 2:00'
    // let start = dateString1.split(' ');
    // let end = dateString2.split(' ');
    // start = Date.parse(start[0]);
    // end = Date.parse(end[0]);

    // let numberOfDays = (end - start) / 1000 / 3600 / 24;

    // // special case, is afterhour. when over 8 hour and ending 5:30 or after

    // console.log(numberOfDays + 1);



    scheduler.skin = "material";
    scheduler.config.header = [
      "day",
      "week",
      "month",
      "date",
      "prev",
      "today",
      "next",
    ];

    this.$_initDataProcessor();
    scheduler.config.drag_resize = false;
    scheduler.config.drag_move = false;
    scheduler.config.drag_create = false;
    scheduler.config.readonly = true;
    scheduler.config.resize_month_events = true;
    scheduler.config.resize_month_timed = true;
    scheduler.config.day_date = "%D %M %j";
    scheduler.config.default_date = "%D %j %M %Y";
    scheduler.templates.day_date = function (date) {
      var formatFunc = scheduler.date.date_to_str(scheduler.config.default_date);
      return formatFunc(date);
    };
    scheduler.init(
      this.$refs.SchedulerComponent,
      new Date(new Date().getFullYear(), new Date().getMonth(), 7),
      "month"
    );
    scheduler.plugins({
        tooltip: true
    });
    scheduler.config.lightbox.sections=[
        // {name:"description", height:72, map_to:"text", type:"textarea" , focus:true},
        {name:"Hours", height:72, type:"select", map_to:"hours", options:[
            {key:"1", label:"1"},
            {key:"1.5", label:"1.5"},
            {key:"2", label:"2"},
            {key:"2.5", label:"2.5"},
            {key:"3", label:"3"},
            {key:"3.5", label:"3.5"},
            {key:"4", label:"4"},
        ]},
        {name:"People", height:72, type:"select", map_to:"people", options:[
            {key:"1", label:"1"},
            {key:"2", label:"2"},
            {key:"3", label:"3"},
            {key:"4", label:"4"},
            {key:"5", label:"5"},
            {key:"6", label:"6"},
            {key:"7", label:"7"},
        ]},
        {name:"time", height:72, type:"time", map_to:"auto" }
    ];
    scheduler.clearAll();
    scheduler.parse(this.$props.events);
  },
};
</script>

<style scoped>
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";

</style>